{createContext} = require 'react'

context = createContext
	root: yes

export default context